/* eslint-disable class-methods-use-this */
import { IAuthApiService } from 'api/AuthApiService';
import Token from 'types/models/Token';

export default class InMemoryAuthApiService implements IAuthApiService {
  private token: Token | null = null;

  public async getAuthAuthorization(): Promise<string> {
    return Promise.resolve('fake-auth-url');
  }

  async getAuthAuthorizationLogout(): Promise<string> {
    return Promise.resolve('fake-auth-url');
  }

  public async getAuthCode(authUri: string): Promise<{ tokenUri: string }> {
    return Promise.resolve({ tokenUri: 'fake-token-uri' });
  }

  public async getAuthToken(tokenSource: string | Token): Promise<Token> {
    const token: Token =
      typeof tokenSource === 'string'
        ? {
            access_token: 'fake-access-token',
            id_token: 'fake-id-token',
            refresh_token: 'fake-refresh-token',
            expires_in: 3600,
            token_type: 'Bearer',
            expires_at: Date.now() + 3600 * 1000,
          }
        : tokenSource;

    this.setLocalStorageToken(token);
    this.token = token;

    return Promise.resolve(token);
  }

  public async getTokenUri(code: string): Promise<{ tokenUri: string | Token }> {
    const token: Token = {
      access_token: 'fake-access-token',
      id_token: 'fake-id-token',
      refresh_token: 'fake-refresh-token',
      expires_in: 3600,
      token_type: 'Bearer',
      expires_at: Date.now() + 3600 * 1000,
    };

    return Promise.resolve({ tokenUri: token });
  }

  public async getRefreshTokenUri(refresh_token: string): Promise<{ tokenUri: string | Token }> {
    const token: Token = {
      access_token: 'fake-access-token',
      id_token: 'fake-id-token',
      refresh_token: 'fake-refresh-token',
      expires_in: 3600,
      token_type: 'Bearer',
      expires_at: Date.now() + 3600 * 1000,
    };

    return Promise.resolve({ tokenUri: token });
  }

  // eslint-disable-next-line class-methods-use-this
  public setLocalStorageToken(data: Token): void {
    const tokenAlreadyPresent = localStorage.getItem('cognito-token');
    let dataToStock = data;
    if (tokenAlreadyPresent) {
      dataToStock = { ...JSON.parse(tokenAlreadyPresent), ...data };
    }
    dataToStock.expires_at = Date.now() + (dataToStock.expires_in as number) * 1000;
    localStorage.setItem('cognito-token', JSON.stringify(dataToStock));
  }

  /**
   * Logout method for test mode - clears localStorage and returns fake logout URL
   */
  public async logout(): Promise<string> {
    // Clear all authentication data
    localStorage.removeItem('cognito-token');
    localStorage.removeItem('active_customer');
    localStorage.removeItem('navigation_screen');
    sessionStorage.clear();

    // Return fake Cognito logout URL for testing
    return Promise.resolve(
      'https://fake-cognito.auth.region.amazoncognito.com/logout?client_id=fake-client&logout_uri=https://fake-app.com'
    );
  }
}
